<template>
  <b-container v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      class="text-center mt-2"
      header="Státuszok szerkesztése"
      border-variant="primary"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <b-card-body class="text-left">
        <div class="col-sm-12">
          <div class="row-fluid">
            <!-- // FORM -->
            <b-form @submit="addElement">
              <div class="form-group">
                <label for="megnevezes">Megnevezés</label>
                <b-form-input
                  size="sm"
                  type="text"
                  v-model="list.megnevezes"
                  class="form-control"
                  id="megnevezes"
                  required
                />
              </div>

              <!-- // SAVE -->
              <b-button variant="primary" type="submit">
                <b-icon-cloud-upload></b-icon-cloud-upload>
                Mentés
              </b-button>

              <!-- // CANCEL -->
              <b-button
                variant="outline-danger"
                class="float-right"
                @click="
                  $router.push({
                    name: 'Status'
                  })
                "
                ><b-icon-arrow-left></b-icon-arrow-left>
                Mégsem</b-button
              >
            </b-form>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'

export default {
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      list: {}
    }
  },
  methods: {
    addElement: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = this.list.id
        payload.token = this.token
        payload.userType = this.userType
        payload.megnevezes = this.list.megnevezes
        axios
          .post(process.env.ROOT_API+'/status/save', { payload })
          .then(res => {
            this.$router.push({ name: 'Status' })
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.id = id
      payload.token = this.token
      payload.userType = this.userType
      if (id) {
        axios
          .post(process.env.ROOT_API+'/status/edit', { payload })
          .then(res => {
            this.list = res.data
            console.log(this.list)
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StatusNew.vue